import React from "react";
import {
  Box,
  Avatar,
  Typography,
  Stack,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import BadgeImage from "../../../components/badges_image/badgesImage";

const badgeImages = {
  bronze: "/img/badges_images/bronze.png",
  silver: "/img/badges_images/silver.png",
  gold: "/img/badges_images/gold.png",
  platinum: "/img/badges_images/platinum.png",
  diamond: "/img/badges_images/diamond.png",
};

const EmployeeCard = ({ data, index }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        backgroundColor: "rgba(246, 96, 95, 0.05)",
        borderRadius: "10px",
        border: "1px solid rgba(204, 204, 204, 1)",
        padding: 2,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
      }}
    >
      <Box
        sx={{
          flex: 1,
          pr: 2,
          borderRight: "1px solid #e0e0e0",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          pb={2}
          style={{ borderBottom: "1px solid #e0e0e0" }}
        >
          <Avatar
            src={data.employee.avatar}
            alt={data.employee.firstName}
            sx={{ width: 30, height: 30 }}
          />

          <Typography
            variant="h6"
            fontWeight={600}
            sx={{ fontSize: isMobile ? "10px" : "16px" }}
          >
            {data.employee.name} {data.employee.lastName}
          </Typography>
        </Stack>

        <Box mt={2}>
          <Typography
            color="text.secondary"
            sx={{ fontSize: isMobile ? "8px" : "14px" }}
          >
            Readings
          </Typography>
          <Typography sx={{ fontSize: isMobile ? "10px" : "16px" }}>
            {data.readings} cards completed
          </Typography>
        </Box>

        <Box mt={1}>
          <Typography
            color="text.secondary"
            sx={{ fontSize: isMobile ? "8px" : "14px" }}
          >
            Points
          </Typography>
          <Typography sx={{ fontSize: isMobile ? "10px" : "16px" }}>
            {data.total_points}
          </Typography>
        </Box>

        <Box mt={1}>
          <Typography
            color="text.secondary"
            sx={{ fontSize: isMobile ? "8px" : "14px" }}
          >
            Micro Trainings
          </Typography>
          <Typography sx={{ fontSize: isMobile ? "10px" : "16px" }}>
            {data.trainings}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          flex: "0 0 160px",
          pl: 2,
          display: "flex",
          flexWrap: "nowrap",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <Typography
          fontWeight={500}
          color="text.secondary"
          mb={1}
          sx={{ fontSize: isMobile ? "8px" : "14px" }}
        >
          Badges Earned
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          {data.badges.map((badge) => (
            <Box key={badge.badgeName} sx={{ textAlign: "center", width: 40 }}>
              <BadgeImage
                badgeName={(badge.badgeName || "default").toLowerCase()}
                altText={badge.badgeName || "Default Badge"}
                width={40}
                height={40}
              />
              <Typography
                variant="body2"
                sx={{ fontSize: isMobile ? "10px" : "12px" }}
              >
                {badge.count}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default EmployeeCard;
